import { baseUrl } from '../constants/baseUrl';
import {
    NOT_IN_STORE
} from '../constants/ActionTypes';

export const sendMemberUpdateAction = (paramsObj, onSuccess, onFailure) => ({
    type: NOT_IN_STORE,
    payload: paramsObj,
    meta: {
        type: 'api',
        url: baseUrl + '/add_membership_update',
        onSuccess: onSuccess,
        onFailure: onFailure,
        params: {},
        options: {
            method: 'PUT',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(paramsObj)
        }
    }
})
